import { Scrollable } from '@ztechapps/webui.util'
import React from 'react'
import { TableAndLoadMoreContent } from './TableAndLoadMoreContent'
import type { TableProps } from './index'
import styles from './table.module.scss'

export const ScrollableContent = (props: TableProps) => {
  const { height, responsive } = props

  //if the height is number convert it to the vh
  let finalHeight = height
  if (typeof height === 'number') {
    finalHeight = height + 'vh'
  }

  return (
    <Scrollable height={finalHeight as string} className={`${styles.fixedTableHeadFoot}  ${responsive ? 'table-responsive' : ''} `}>
      <TableAndLoadMoreContent {...props} />
    </Scrollable>
  )
}
